module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/vimeo.ee8dbc66790c4c5249bfc95d01b7b087.png";